import React from 'react';
import { Box, Button, Paper } from "@mui/material";

const tabs = [
    { id: 1, label: 'Basic' },
    { id: 2, label: 'Advanced' }
];

const ServerTabs = ({ activeTab, onTabChange }) => {
    return (
        <Paper className="tabs-container">
            <Box className="tabs-wrapper">
                {tabs.map(tab => (
                    <Button
                        key={tab.id}
                        className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => onTabChange(tab.id)}
                    >
                        {tab.label}
                    </Button>
                ))}
            </Box>
        </Paper>
    );
};

export default ServerTabs;